import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { IReceiptFilters } from "src/types/molecules";
const ReceiptFilters = ({
  handleExpiredFilter,
  handleStatusFilter
}: IReceiptFilters) => {
  return <>
      <FormControl variant="outlined" sx={{
      minWidth: 120
    }}>
        <InputLabel id={"expiredLabel"}>En mora</InputLabel>
        <Select labelId={"expiredLabel"} label="En mora" defaultValue={""} sx={{
        width: 120
      }} onChange={e => handleExpiredFilter(Number(e.target.value))}>
          <MenuItem value={0}>
            <em>Todos</em>
          </MenuItem>
          <MenuItem value={2}>Sí</MenuItem>
          <MenuItem value={1}>No</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="outlined" sx={{
      minWidth: 120
    }}>
        <InputLabel id={"statusLabel"}>Estado</InputLabel>
        <Select labelId={"statusLabel"} label="Estado" defaultValue={""} sx={{
        width: 120
      }} onChange={e => handleStatusFilter(e.target.value)}>
          <MenuItem value={""}>
            <em>Todos</em>
          </MenuItem>
          <MenuItem value={"1"}>Activo</MenuItem>
          <MenuItem value={"2"}>Cerrado</MenuItem>
        </Select>
      </FormControl>
    </>;
};
export default ReceiptFilters;